/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationAppIcon24Solid = forwardRef('NotificationAppIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19 9.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z" }),
        React.createElement("path", { d: "M19 11.5a6.472 6.472 0 0 0 3-.732V17.5a4.5 4.5 0 0 1-4.5 4.5h-11A4.5 4.5 0 0 1 2 17.5v-11A4.5 4.5 0 0 1 6.5 2h6.732A6.5 6.5 0 0 0 19 11.5Z" })));
});
